import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "@nook/ui";
import { Streamdown } from "streamdown";
/**
 * Markdown as Nook reads it: an article's extracted body and Ask's answers.
 * Streamdown because an answer is rendered mid-stream, where an unclosed `**`
 * or a half-built list must not flash as syntax.
 */
export function Markdown({ children, streaming = false, className, components, }) {
    return (_jsx(Streamdown, { mode: streaming ? "streaming" : "static", isAnimating: streaming, controls: false, linkSafety: { enabled: false }, components: components ?? {}, className: cn("max-w-[70ch] space-y-3 text-sm leading-relaxed text-pretty", className), children: children }));
}
//# sourceMappingURL=markdown.js.map